export default __webpack_public_path__ + "static/media/TrashIcon.cfc12324.svg";